export default "__VITE_ASSET__CixeWB0f__"